import axios from "axios";

import {removeCookie} from "@/utils/functions";
import {RESPONSE_STATUSES} from "@/utils/constants";

const DOMAIN = process.env.VUE_APP_API_DOMAIN || "https://lk.poools.top/";
const API_URL = DOMAIN.replace(/\/?$/, "/") + "api/v1";

const http = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

// No request interceptor needed: httpOnly cookie is sent automatically by the browser
// when withCredentials: true is set above.

http.interceptors.response.use(
    (config) => {
        return config;
    },
    async (error) => {
        const request = error.config;
        const status = error.response && error.response.status;

        if (
            status === RESPONSE_STATUSES.auth &&
            error.config &&
            !error.config._isRetry
        ) {
            try {
                request._isRetry = true;

                // refreshToken httpOnly cookie is sent automatically — no body needed
                await axios
                    .post(`${API_URL}/auth/refresh`, {}, { withCredentials: true })
                    .then(async (response) => {
                        const {status} = response.data;

                        if (status === RESPONSE_STATUSES.error) {
                            removeCookie("accessToken");
                            removeCookie("refreshToken");

                            const {default: router} = await import("@/router");
                            router.push("/login");
                        }
                        // Server sets new cookies via Set-Cookie — nothing to store manually
                    });

                return http.request(request);
            } catch (e) {
                removeCookie("accessToken");
                removeCookie("refreshToken");

                const {default: router} = await import("@/router");
                router.push("/login");
            }
        }

        throw error;
    }
);

export default http;
export { DOMAIN, API_URL };
